module.exports = __webpack_public_path__ + "img/H-B-6-load-connect-shadow.38b0233d.png";